export function assertNever(value: never) {
  throw new Error(`Unhandled value: ${value}`);
}
